/**
 * Client Module - Central export point
 *
 * This file provides convenient re-exports for all client module components,
 * hooks, types, store, and utilities.
 *
 * Usage: import { Component, Type, hook } from "@client"
 */

// Types
export * from "./types";

// Components
export * from "./components";

// Hooks
export * from "./hooks";

// Store (Redux)
export * from "./store";

// Utils
export * from "./utils";

// Actions (Server Actions)
export * from "./actions";
